export const COLLECTION_ALLOCATIONS_REQUEST =
  "API/ENTITIES/COLLECTION_ALLOCATIONS_REQUEST";
export const COLLECTION_ALLOCATIONS_REQUEST_FAILURE =
  "API/ENTITIES/COLLECTION_ALLOCATIONS_REQUEST_FAILURE";
export const COLLECTION_ALLOCATIONS_REQUEST_SUCCESS =
  "API/ENTITIES/COLLECTION_ALLOCATIONS_REQUEST_SUCCESS";
